import { HttpStatusCode } from "../../../common/http-status-code";

const DEFAULT_MESSAGE = "Al momento sembra che molti utenti stiano utilizzando Clara. Riprova tra qualche minuto.";

export class RateLimitExceededError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "RateLimitExceededError";
  }

  public static create(message: string = DEFAULT_MESSAGE): RateLimitExceededError {
    return new RateLimitExceededError(message);
  }

  public static withMessage(message: string): RateLimitExceededError {
    return new RateLimitExceededError(message);
  }

  public static fromError(error: Error): RateLimitExceededError {
    return new RateLimitExceededError(error.message);
  }

  public static isRateLimitExceeded(eventData: string): boolean {
    const lowerCaseEventData = eventData.toLowerCase();

    const hasRateLimitMessage =
      lowerCaseEventData.includes("rate limit") ||
      lowerCaseEventData.includes("too many requests") ||
      lowerCaseEventData.includes("throttling") ||
      lowerCaseEventData.includes("ratelimitexceededexception") ||
      lowerCaseEventData.includes("quota exceeded") ||
      lowerCaseEventData.includes(HttpStatusCode.TOO_MANY_REQUESTS.toString());

    try {
      const parsedData = JSON.parse(eventData);
      if (
        parsedData?.data?.name === "RateLimitExceededException" ||
        parsedData?.data?.status === 429 ||
        parsedData?.data?.isRateLimitError === true
      ) {
        return true;
      }
    } catch {
      // If parsing fails, fallback to string matching
    }

    return hasRateLimitMessage;
  }

  public static fromEventDataIfMatches(eventData: string, message?: string): RateLimitExceededError | null {
    if (this.isRateLimitExceeded(eventData)) {
      return new RateLimitExceededError(message || "Rate limit exceeded");
    }
    return null;
  }

  public static isRateLimitExceededError(error: unknown): error is RateLimitExceededError {
    return error instanceof RateLimitExceededError;
  }
}
